import * as React from 'react'
function SvgNotification(props) {
	return (
		<svg
			width="1em"
			height="1em"
			viewBox="0 0 40 40"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M23.5 30.5A3.51 3.51 0 0120 34a3.51 3.51 0 01-3.5-3.5zM20 6c4.9 0 8.75 3.85 8.75 8.75V20c0 2.275 1.4 4.025 2.625 5.25h.875c1.05 0 1.75.7 1.75 1.75s-.7 1.75-1.75 1.75H7.75C6.7 28.75 6 28.05 6 27s.7-1.75 1.75-1.75h.875C9.85 24.025 11.25 22.275 11.25 20v-5.25C11.25 9.85 15.1 6 20 6z"
				fill="currentColor"
				fillRule="evenodd"
			/>
		</svg>
	)
}
export default SvgNotification
